import enMessages from '../locales/fi_FI.json';

const FiLang = {
  messages: {
    ...enMessages
  },
  locale: 'fi-FI',
};
export default FiLang;
